// src/components/NoResults.jsx
import React from "react";
import "./NoResults.css";
import emptyIllustration from "../../assets/no-results-theme.png"; // ensure this file exists

export default function NoResults({
                                      query = "",
                                      message = "Try adjusting filters or searching for something else.",
                                      className = "",
                                      imageSrc = emptyIllustration,
                                      imageAlt = "No results illustration",
                                  }) {
    return (
        <section className={`noresults ${className}`} aria-labelledby="noresults-title">
            <img
                className="noresults__image"
                src={imageSrc}
                alt={imageAlt}
                loading="lazy"
            />
        </section>
    );
}
